import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { Card, Table, Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { RoleContext } from "../../RoleContext";
import TableSmall from "../../Theme/TableSmall";
import AssignHospitalModal from "./AssignHospitalModal";

const HospitalDetail = () => {

    const roleData = useContext(RoleContext);
    const role = JSON.parse(roleData);


    const { specialtyId } = useParams();
    const [hospital, setHospital] = useState([]);
    const [specialties, setSpecialties] = useState(null);

    const [showAssignModal, setShowAssignModal] = useState(false);

    const handleOpenAssignModal = () => setShowAssignModal(true);
    const handleCloseAssignModal = () => setShowAssignModal(false);

    const fetchSpeciality = async () => {
        try {
            const { data } = await axios.get(`/specialties/${specialtyId}/hospitals`);
            setHospital(data.hospitals || []);
            setSpecialties(data);
        } catch (error) {
            console.error("Failed to fetch speciality details:", error);
        }
    };

    useEffect(() => {
        fetchSpeciality();
    }, [specialtyId]);


    const deleteHospital = async (hospital_id, speciality_id) => {
        try {
            await axios.post(`/remove_hospital`, { specialtyId: speciality_id, hospitalIds: [hospital_id] });
            fetchSpeciality();
        } catch (error) {
            console.error("Failed to delete hospital:", error);
        }
    };


    const hospitalColumns = React.useMemo(
        () => [

            {
                Header: "Hospital Lookup",
                columns: [{
                    Header: "Name",
                    accessor: "name",
                    disableFilters: true
                },
                {
                    Header: "Address",
                    accessor: "location",
                    disableFilters: true

                },
                {
                    Header: "Phone",
                    accessor: "phoneNumber",
                    disableFilters: true

                },
                {
                    Header: "Latitude",
                    accessor: "latitude",
                    disableFilters: true,
                    Cell: ({ value }) => (
                        <span>{value ? parseFloat(value).toFixed(2) : "N/A"}</span>
                    ),
                },
                {
                    Header: "Longitude",
                    accessor: "longitude",
                    disableFilters: true,
                    Cell: ({ value }) => (
                        <span>{value ? parseFloat(value).toFixed(2) : "N/A"}</span>
                    ),
                },

                ],
            },
            {
                Header: " ",
                columns: [
                    {
                        Header: "Actions",
                        accessor: "actions",
                        disableFilters: true,
                        Cell: (row) => (
                            <div>
                                {role.filter(function (e) {
                                    return e.perm_name === "delete_hospital";
                                }).length > 0 && (
                                        <Link
                                            to={""}
                                            onClick={(e) => deleteHospital(row.cell.row.original.hospital_id, specialtyId)}
                                        >
                                            <i className="fas fa-trash error" />
                                        </Link>
                                    )}
                            </div>
                        )
                    },

                ],
            }
        ]
    )

    if (!specialties) return <div className="text-center my-4">Loading...</div>;

    return (
        <div className="content-wrappers">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>Speciality Details</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/ambulance_lookup">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Speciality Detail</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="content">
                <Container fluid>
                    <Row>
                        <Col md={4}>
                            <Card>
                                <Card.Header>
                                    <h3 className="card-title">Speciality Details</h3>
                                </Card.Header>
                                <Card.Body>
                                    <p><b>Speciality Name: </b> {specialties.name}</p>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={8}>
                            <Card>
                                <Card.Header>
                                    <h3 className="card-title">Hospitals </h3>
                                    <Button
                                        onClick={handleOpenAssignModal}
                                        className="btn btn-success bt"
                                    >
                                        Assign Hospital
                                    </Button>
                                </Card.Header>
                                <Card.Body>
                                    <TableSmall data={hospital} columns={hospitalColumns} />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            <AssignHospitalModal
                showModal={showAssignModal}
                hideModal={handleCloseAssignModal}
                specialtyId={specialtyId}
                assignedHospitals={hospital}
                onSuccess={fetchSpeciality}
            />
        </div>
    );
};

export default HospitalDetail;
